function SubAbasUser(fichaID: string): { label: string; rota: string }[] {
  return [
    {
      label: 'Usuários',
      rota: `/fornecedor/adm/usuarios/ficha/${fichaID}/dadosgerais`,
    },
  ];
}

export default SubAbasUser;
